import { createAsyncThunk } from "@reduxjs/toolkit";

import api from "../../../utils/api";
import { RootState } from "../../rootReducer";
import { findFormListByProfile } from "./findFormListByProfile";

// Asigna plantillas al perfil
export const assignFormToProfile = createAsyncThunk(
  "userProfileLocation/assignLocations",
  async (arg, { rejectWithValue, getState, dispatch }) => {
    try {
      const state = getState() as RootState;
      const preselectedForm = state.profileFormAssigned.preselectedForms;
      const formsToSave = preselectedForm.map((item) => item.id);
      const assignedForms = state.profileFormAssigned.assignedForms;
      const idsToDelete: string[] = [];

      // Se comprueba si los from ya asignados se encuentran dentro de los preseleccionados.
      // Si los encuentra los elimina del listado para crear registros (FormToSave).
      // Si no los encuentra guarda el id en listado para eliminar registros (IdsToDelete).
      assignedForms.forEach(async (element) => {
        if (formsToSave.includes(element.id)) {
          const indexToDelete = formsToSave.indexOf(element.id);
          formsToSave.splice(indexToDelete, 1);
        } else {
          idsToDelete.push(element.pfId);
        }
      });
      const token = localStorage.getItem("token");
      const headers = new Headers();
      headers.append("Authorization", `Bearer ${token}`);
      headers.append("Content-Type", "application/json");

      // Eliminar registros
      if (idsToDelete.length > 0) {
        const url = new URL(`${api.baseURL}profileform/delete-list`);
        let response = await fetch(url.toJSON(), {
          body: JSON.stringify({
            toDelete: idsToDelete.toString(),
          }),
          method: "POST",
          headers: headers,
        });
        if (!response.ok) {
          throw response.statusText;
        }
      }

      // Crea registros
      if (formsToSave.length > 0) {
        const url = new URL(`${api.baseURL}profileform/create-list`);
        let response = await fetch(url.toJSON(), {
          body: JSON.stringify({
            profile: state.profileDetail.profile.id,
            toAddFormIds: formsToSave.toString(),
          }),
          method: "POST",
          headers: headers,
        });
        if (!response.ok) {
          throw response.statusText;
        }
      }
      dispatch(findFormListByProfile(state.profileDetail.profile.id));
    } catch (error) {
      return rejectWithValue(error);
    }
  },
);
